import { encode } from "querystring";
import { useEffect } from "react";

import { useRouter } from "next/router";

import schoolQueryKey from "@/constants/SCHOOL_REGISTRATION_QUERY_KEYS";

const useRemoveSchoolQueryParam = (callback?: () => void) => {
  const router = useRouter();

  useEffect(() => {
    const { CONFIRMATION_KEY } = schoolQueryKey;

    if (router.query[CONFIRMATION_KEY]) {
      const queryParams = new URLSearchParams(encode(router.query));
      queryParams.delete(CONFIRMATION_KEY);
      router.replace(
        {
          pathname: router.pathname,
          query: Object.fromEntries(queryParams),
        },
        undefined,
        { shallow: true },
      );
      typeof callback === "function" && callback();
    }
  }, [router.query, callback, router.pathname]);
};

export default useRemoveSchoolQueryParam;
